import jQuery from 'jquery';

jQuery(function($) {
  let $vacancyList = $('.vacancy__list');
  let $vacancyItems = $vacancyList.find('.vacancy__item');

  $vacancyItems.each(function() {
    let $vacancyItem = $(this);

    let $name = $vacancyItem.find('.vacancy__name');
    let $info = $vacancyItem.find('.vacancy__info');

    $name.on('click', function() {
      let isActive = $vacancyItem.hasClass('vacancy__item--active');

      $vacancyItem.toggleClass('vacancy__item--active', !isActive);

      if (isActive) {
        $info.slideUp();
      } else {
        $info.slideDown();
      }
    });
  });
});
